

export const InsuranceStatus = {
    ACTIVE: 'Active',
    SUSPENDED: 'Paused',
    SCHEDULED: 'Scheduled',
    EXPIRED: 'Expired',
    CANCELED: 'Canceled'
}